import { useEffect, useState } from 'react';
import { ClienteSessao, type EstadoAuth } from '../data/session.js';

/** `carregando` so existe aqui: o resto do app ve um estado ja resolvido. */
export type EstadoAuthUi = EstadoAuth | { tipo: 'carregando' };

/**
 * Base da API do middleware.
 *
 * Vem de `VITE_API_URL` para o mesmo build servir dev e producao. O padrao e
 * loopback: se a variavel faltar em producao o console fala com um endereco
 * que nao existe e o erro aparece na hora — melhor do que apontar para um
 * host adivinhado.
 */
export function baseDaApi(env: Record<string, string | undefined>): string {
  return env.VITE_API_URL ?? 'http://127.0.0.1:3000';
}

/**
 * Descobre quem esta logado, uma vez, na montagem.
 *
 * A sessao e resolvida ANTES do console montar porque os papeis do operador
 * entram no motor na construcao. Montar primeiro e corrigir depois abriria uma
 * janela em que o console aceita comando com a permissao errada.
 */
export function useAuth(cliente: ClienteSessao): EstadoAuthUi {
  const [estado, setEstado] = useState<EstadoAuthUi>({ tipo: 'carregando' });

  useEffect(() => {
    let vivo = true;
    void cliente.carregar().then((resultado) => {
      // O StrictMode monta duas vezes em desenvolvimento: sem esta guarda a
      // resposta da montagem descartada ainda escreveria no estado.
      if (vivo) setEstado(resultado);
    });
    return () => {
      vivo = false;
    };
  }, [cliente]);

  return estado;
}
